import React, { memo, useMemo } from 'react'
import { Grid, Typography } from '@mui/material'
import { Clipboard, DialogPopup } from '../components'
import { translate } from '../i18n'
import { AnalyticsSharePopupProps } from './AnalyticsSharePopup.types'

const EMBED_PATH = '/embed/analytics'
const IFRAME_HEIGHT = 520

function AnalyticsSharePopup({ projectId, onClose }: AnalyticsSharePopupProps) {
    const shareUrl = useMemo(() => {
        const origin = process.env.REACT_APP_ROOT_URL ?? window.location.origin
        return `${origin}${EMBED_PATH}?projectId=${encodeURIComponent(
            projectId
        )}`
    }, [projectId])

    const iframeSnippet = useMemo(
        () =>
            `<iframe src="${shareUrl}" width="100%" height="${IFRAME_HEIGHT}" style="border:0" title="Analytics"></iframe>`,
        [shareUrl]
    )

    return (
        <DialogPopup
            title={translate('projects.analytics.share.title') as string}
            onClose={onClose}
            disableBackdropClick={false}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                        {translate('projects.analytics.share.description')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Clipboard
                        value={shareUrl}
                        label={
                            translate('projects.analytics.share.link') as string
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <Clipboard
                        value={iframeSnippet}
                        label={
                            translate(
                                'projects.analytics.share.iframe'
                            ) as string
                        }
                    />
                </Grid>
            </Grid>
        </DialogPopup>
    )
}

export default memo(AnalyticsSharePopup)
